var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wa-ui-page",
      class: { "wa-ui-page--mobile": _vm.mobileMode },
    },
    [
      !_vm.mobileMode
        ? [
            _vm.showChannelSwitcher
              ? _c("WAChannelSwitcher", {
                  attrs: {
                    channels: _vm.visibleChannels,
                    "selected-channel-id": _vm.selectedChannelId,
                    "total-unread": _vm.totalUnreadCount,
                  },
                  on: {
                    change: _vm.onChannelChange,
                    "open-settings": _vm.openChannelSettings,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("WAContactList", {
              ref: "contactList",
              attrs: {
                "selected-contact": _vm.selectedContact,
                "selected-channel": _vm.selectedChannel,
                "hide-inbox": _vm.qp.hideInbox,
              },
              on: { "contact-selected": _vm.onContactSelected },
            }),
            _vm._v(" "),
            _vm.selectedContact && _vm.selectedContact.lastConversation
              ? _c("WAChatArea", {
                  key: _vm.selectedContact._id,
                  attrs: {
                    contact: _vm.selectedContact,
                    channel: _vm.getContactChannel(_vm.selectedContact),
                  },
                })
              : _c("WAEmptyState"),
          ]
        : [
            _c("transition", { attrs: { name: _vm.slideDirection } }, [
              _vm.mobileView === "list"
                ? _c(
                    "div",
                    { key: "list", staticClass: "wa-mobile-screen" },
                    [
                      _vm.showChannelSwitcher
                        ? _c(
                            "div",
                            { staticClass: "wa-mobile-channel-tabs" },
                            [
                              !_vm.qp.forcedChannelId
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "wa-mobile-channel-tab",
                                      class: {
                                        "wa-mobile-channel-tab--active":
                                          _vm.selectedChannelId === null,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onChannelChange(null)
                                        },
                                      },
                                    },
                                    [_vm._v("Tümü")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.visibleChannels, function (ch) {
                                return _c(
                                  "button",
                                  {
                                    key: ch._id,
                                    staticClass: "wa-mobile-channel-tab",
                                    class: {
                                      "wa-mobile-channel-tab--active":
                                        _vm.selectedChannelId === ch._id,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onChannelChange(ch._id)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        ch.name ||
                                          _vm.getChannelShortLabel(ch.type)
                                      )
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("WAContactList", {
                        ref: "contactList",
                        attrs: {
                          "selected-contact": _vm.selectedContact,
                          "selected-channel": _vm.selectedChannel,
                          "mobile-mode": true,
                          "hide-inbox": _vm.qp.hideInbox,
                        },
                        on: { "contact-selected": _vm.onMobileContactSelected },
                      }),
                    ],
                    1
                  )
                : _vm.mobileView === "chat"
                ? _c(
                    "div",
                    { key: "chat", staticClass: "wa-mobile-screen" },
                    [
                      _vm.selectedContact &&
                      _vm.selectedContact.lastConversation
                        ? _c("WAChatArea", {
                            key: _vm.selectedContact._id,
                            attrs: {
                              contact: _vm.selectedContact,
                              channel: _vm.getContactChannel(
                                _vm.selectedContact
                              ),
                              "mobile-mode": true,
                            },
                            on: { back: _vm.goBackToList },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }